import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Tag({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Tag.Outline {...props} /> : <Tag.Solid {...props} />;
}

Tag.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <line
          x1="2"
          y1="10"
          x2="22"
          y2="10"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="icon-outline"
        />
        <line
          x1="2"
          y1="16"
          x2="22"
          y2="16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="icon-outline"
        />
        <line
          x1="7"
          y1="4"
          x2="9"
          y2="20"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="icon-outline"
        />
        <line
          x1="15"
          y1="4"
          x2="17"
          y2="20"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Tag.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <line
          x1="2"
          y1="10"
          x2="22"
          y2="10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="2"
          y1="16"
          x2="22"
          y2="16"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="7"
          y1="4"
          x2="9"
          y2="20"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="15"
          y1="4"
          x2="17"
          y2="20"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
